// The quick tour: a minute of plain words on what each page is for. Pure data, so the steps can be tested
// without a DOM; the card that shows them is components/Tour.tsx.
import type { Page } from '../state.tsx';

export type TourStep = {
  id: string;
  title: string;
  body: string;
  /** The page shown behind the card while this step is up */
  page: Page;
  /** The element the step talks about, by its `data-tour` attribute: it gets a ring */
  target?: string;
  /** Docs page for the "Read more" link, e.g. `learn/trades-pricing` */
  docs?: string;
  /** An action button under the text */
  action?: 'deposit';
};

/** localStorage key; the tour opens by itself once, on the first visit of the trade page */
export const TOUR_STORAGE_KEY = 'papurr:tour';

export const TOUR: TourStep[] = [
  {
    id: 'welcome',
    page: 'trade',
    title: 'Welcome to Papurrtrade',
    body:
      "Perpetuals on one market, HYPE, with high leverage, on HyperEVM. You trade against the house at Hyperliquid's prices, pay no gas and no funding, and can never lose more than your margin. This tour takes a minute.",
    docs: 'intro/what-is-papurrtrade',
  },
  {
    id: 'trade',
    page: 'trade',
    target: 'order',
    title: 'Place a trade',
    body:
      'Pick Long or Short, a margin and a leverage, then confirm. A market order fills in the next block at the worse of the book mid and the mark; limit orders and take profits wait for your price. Enable one-click trading once and the wallet stops popping up on every order.',
    docs: 'learn/trades-pricing',
  },
  {
    id: 'deposit',
    page: 'trade',
    target: 'deposit',
    title: 'Fund your balance',
    body:
      "Deposit USDC from HyperCore (Hyperliquid spot) to your personal deposit address, from HyperEVM in one flow, or from Arbitrum, Base, Ethereum and other chains through Circle's CCTP. Withdrawals go back to HyperCore or to HyperEVM.",
    docs: 'learn/deposits-withdrawals',
    action: 'deposit',
  },
  {
    id: 'portfolio',
    page: 'portfolio',
    target: 'nav-portfolio',
    title: 'Follow your positions',
    body:
      'Open positions with their live PnL and bust price, resting limit orders, closed trades, transfers and your PnL over time. A win the house cannot pay on the spot waits in a first-in, first-out queue and is paid as the house refills.',
    docs: 'learn/house-queue',
  },
  {
    id: 'house',
    page: 'house',
    target: 'nav-house',
    title: 'The house',
    body:
      'The protocol-owned pool on the other side of every trade: what it holds, what it owes, how much open interest it still accepts and the payout queue. It grows on losses and shrinks on wins, in the open.',
    docs: 'how/house-reserve',
  },
  {
    id: 'papurr',
    page: 'papurr',
    target: 'nav-papurr',
    title: "PAPURR, the loser's token",
    body:
      'Every losing close mints PAPURR to you. Stake it for a share of the protocol revenue, paid in HYPE bought back on HyperCore: claim it on HyperCore or straight to this wallet, or convert it to USDC and trade again. The burn auction lives here too.',
    docs: 'papurr/overview',
  },
  {
    id: 'docs',
    page: 'docs',
    target: 'nav-docs',
    title: 'Dig deeper',
    body:
      'Pricing, the payout curve, liquidations, the mint curve, admin keys and risks: the docs explain every number. Replay this tour any time from the ? in the header. Good luck out there.',
  },
];
